import router, { constantRoutes } from './router'
import store from './store'
import { showLoginExpiredDialog } from '@/utils/request'
import { Message } from 'element-ui'

const whiteList = ['/login']

function resolvePath(parent, child) {
  return `${parent}/${child}`.replace(/\/+/g, '/')
}

function firstAllowedRoutePath(route, menus, parentPath = '') {
  if (route.hidden || route.path === '/login') return ''
  const currentPath = resolvePath(parentPath, route.path)
  const children = route.children || []
  if (children.length) {
    for (const child of children) {
      const childPath = firstAllowedRoutePath(child, menus, currentPath)
      if (childPath) return childPath
    }
    return ''
  }
  const menuKey = route.meta && route.meta.menuKey
  return menuKey && menus.includes(menuKey) ? currentPath : ''
}

function firstAllowedMenuPath(menus) {
  for (const route of constantRoutes) {
    const path = firstAllowedRoutePath(route, menus)
    if (path) return path
  }
  return ''
}

router.beforeEach(async(to, from, next) => {
  const hasToken = store.getters.token
  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      return
    }
    if (!store.getters.role) {
      try {
        await store.dispatch('loadProfile')
      } catch (error) {
        showLoginExpiredDialog()
        next(false)
        return
      }
    }
    const menuKey = to.meta && to.meta.menuKey
    const menus = (store.getters.permissions && store.getters.permissions.menus) || []
    if (menuKey && !menus.includes(menuKey)) {
      const redirectPath = firstAllowedMenuPath(menus)
      if (redirectPath && redirectPath !== to.path) {
        next({ path: redirectPath })
      } else {
        Message.warning('当前角色没有可访问菜单')
        next(false)
      }
      return
    }
    const viewKey = to.meta && to.meta.viewKey
    const views = (store.getters.permissions && store.getters.permissions.views) || []
    if (viewKey && !views.includes(viewKey)) {
      Message.warning('当前角色没有查看该数据大屏的权限')
      next(false)
      return
    }
    next()
    return
  }

  if (whiteList.includes(to.path)) {
    next()
  } else {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
})
